import { HttpErrorResponse } from '@angular/common/http';

import { ErrorResponseDetail } from '#types/core';

export function errorDetail(response: HttpErrorResponse): ErrorResponseDetail {
  let error: ErrorResponseDetail;

  if (response.error?.error) {
    error = { ...response.error.error };

    return error;
  } else {
    return null;
  }
}
